var _defs, _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhitetophat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    "data-name": "Layer 5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#41bced;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M500,229.5H267v-153a20,20,0,0,1,20-20H480a20,20,0,0,1,20,20Z",
    transform: "translate(-184 -56.5)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 83,
    y: 113,
    width: 233,
    height: 38
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M551.63,255.5H216.37A32.37,32.37,0,0,1,184,223.13h0a20.63,20.63,0,0,1,20.63-20.63H563.37A20.63,20.63,0,0,1,584,223.13h0A32.37,32.37,0,0,1,551.63,255.5Z",
    transform: "translate(-184 -56.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitetophat);
export default __webpack_public_path__ + "static/media/white top hat.02dbe304.svg";
export { ForwardRef as ReactComponent };